import { useMemo } from 'react';

import { getIdsFromPath } from '@/utils/modifiers';

import { OrganizationAncestor, OrganizationAncestorLevel } from '../UnappliedFunds.types';

const ANCESTOR_LEVELS: OrganizationAncestorLevel[] = ['partnerId', 'distributorId', 'employerId'];

interface Params {
  organizationId?: string;
  organizationPath?: string;
}

export const useOrganizationAncestors = ({ organizationId, organizationPath }: Params) =>
  useMemo(() => {
    const ids = getIdsFromPath(organizationPath);
    const ancestors: OrganizationAncestor[] = [];

    for (const level of ANCESTOR_LEVELS) {
      const id = ids[level];
      if (!id || id === organizationId) {
        break;
      }
      ancestors.push({ id, level });
    }

    return ancestors;
  }, [organizationId, organizationPath]);
